<template>
    <div>
        <ul class="afterSale">
            <li>
                <div class="icon">
                    <div class="iosIcon">
                        <Icon type="ios-infinite" />
                    </div>
                    <dl>
                        <dt>产品验收</dt>
                        <dd>
                            <p>需方应于产品交付后3个工作日内对产品品牌、规格型号、数量等进行检查，并依照约定的质量要求和技术标准对产品进行验收；验收不合格的，需方应立即向普拉托提出书面异议，供方在接到异议后及时进行更换，直至验收合格。产品交付后3个工作日内未提出异议则视为产品通过验收。</p>
                        </dd>
                    </dl>
                </div>
            </li>
            <li>
                <div class="icon">
                    <div class="iosIcon">
                        <Icon type="ios-construct-outline" />
                    </div>
                    <dl>
                        <dt>标准质保</dt>
                        <dd>
                            <p>质保期 3 年，质保期从验收合格之日起开始计算，质保期内，产品正常使用情况下，因质量问题出现非人为损坏，将按以下规则免费更换：</p>
                            <p>一年以内，一块坏托盘更换一块新托盘；</p>
                            <p>第二年，二块坏托盘更换一块新托盘；</p>
                            <p>第三年，三块坏托盘更换一块新托盘。</p>

                        </dd>
                    </dl>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {

}
</script>
<style lang="scss" scoped>
.afterSale {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #eee;
    padding: 10px;
    li {
        margin-bottom: 30px;
        .icon {
            display: flex;
            .iosIcon {
                width: 32px;
                height: 32px;
                background: #ff9000;
                border-radius: 50%;
                line-height: 32px;
                text-align: center;
                font-size: 20px;
                color: #fff;
            }
            dl {
                width: 655px;
                margin: 8px 0 0 10px;
                dt {
                    color: #ff9000;
                    font-size: 16px;
                    font-weight: bold;
                    margin-bottom: 5px;
                }
                dd {
                    font-size: 14px;
                    color: #666;
                }
            }
        }
    }
}
</style>